import { async } from 'regenerator-runtime';
import {
  req,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
} from '../js/config';
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};

const Initialize = async () => {
  try {
    await getPageData();
    await generatePageHTML();
    await loadJavascriptNow();
    console.log('getPageData', PageData);
    var loader = document.getElementById('loader-wrapper');
    loader.style.display = 'none';
  } catch (err) {
    var loader = document.getElementById('loader-wrapper');
    loader.style.display = 'none';
    console.log('🚀 ~ file: main.js:14 ~ Initialize ~ err', err);
  }
};

const generatePageHTML = async () => {
  await CottageListData();
};

const generateInlineSlider = (x, d) => {
  // Check if 'small' is defined, otherwise use 'd.attributes.url'
  let imageUrl =
    d.attributes.formats && d.attributes.formats.small
      ? imgServer + d.attributes.formats.small.url
      : imgServer + d.attributes.url;
  let imageAlt =
    d.attributes.formats && d.attributes.formats.small
      ? d.attributes.formats.small.name
      : x.attributes.name;
  let imageTitle =
    d.attributes.formats && d.attributes.formats.small
      ? d.attributes.formats.small.name
      : x.attributes.name;

  let tpl = `<div class="swiper-slide"><div class="img sliderimg aspect-ratio-box">
    <a href="/cottagedetail/${x.id}"><img src="${imageUrl}" class="aspect-ratio-box-inside img-responsive" alt="${imageAlt}" title="${imageTitle}"></a>
    </div>  </div>`;

  return tpl;
};
const generateInlineSliders = (x) => {
  let tpl = ``;

  if (x.attributes.images.data.length > 0) {
    tpl += generateInlineSlider(x, x.attributes.images.data[0]); // Directly access the first image
  }

  return tpl;
};

const CottageListData = async () => {
  let tpl = '';

  PageData.forEach((x) => {
    console.log('🚀 ~ file: main.js:39 ~ PageData.forEach ~ x:', x);

    tpl += `<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="room-item-1">
                        <h2><a href="#">${x.attributes.name}</a></h2>
                        <div class="swiper mySwiper">
                            <div class="swiper-wrapper">   
                            ${generateInlineSliders(
                              x
                            )};                            
                            </div>
                            <div class="swiper-button-next"></div>
                                    <div class="swiper-button-prev"></div>
                        </div>
                        
          
                        <div class="content">
                            <p>${x.attributes.overview.Description}</p>
                            <ul>
                                <li>Bedrooms: ${
                                  x.attributes.overview.Bedrooms
                                }</li>
                                <li>Beds: ${x.attributes.overview.Beds}</li>
                                <li>Guests: ${x.attributes.overview.Guests}</li>
                                <li>Baths: ${x.attributes.overview.Baths}</li>
                            </ul>
                        </div>
                        <div class="bottom">
                            <span class="price">Starting <span class="amout">$${
                              x.attributes.rate
                            }</span> /Night</span>
                            <a href="/cottagedetail/${
                              x.id
                            }" class="btn">VIEW DETAILS</a>
                        </div>
                    </div>
                </div>`;
  });

  document.querySelector('#cottageData').innerHTML = tpl;
};
const getPageData = async () => {
  PageData = window.__COTTAGE_DATA__;

  PageData = PageData.Result;
  console.log('🚀 ~ file: main.js:72 ~ getPageData ~ PageData:', PageData);
};

const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'js/sky.js';

  // Append to the `head` element
  document.head.appendChild(script);
  var swiper = new Swiper('.mySwiper', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

Initialize();
